import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.onyx
};
export default anchor;